import { render, staticRenderFns } from "./DiscountCodeInput.vue?vue&type=template&id=24aa5d7a&scoped=true"
import script from "./DiscountCodeInput.vue?vue&type=script&lang=js"
export * from "./DiscountCodeInput.vue?vue&type=script&lang=js"
import style0 from "./DiscountCodeInput.vue?vue&type=style&index=0&id=24aa5d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa5d7a",
  null
  
)

export default component.exports